import { EngagementFeedsPagedResponse } from '@epicuro-next/data/engagement/engagement-models';
import { createAction, props } from '@ngrx/store';

export const startPolling = createAction('[News Feed] Start Polling Updates');
export const stopPolling = createAction('[News Feed] Stop Polling Updates');

export const fetchUpdates = createAction(
  '[News Feed] Fetch Updates',
  props<{ date: string }>(),
);

export const fetchUpdatesSuccess = createAction(
  '[News Feed] Fetch Updates Success',
  props<{ data: EngagementFeedsPagedResponse }>(),
);
